import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";
import Moment from "react-moment";
//functions
import {
  _t,
  getCookie,
  modalLoading,
  pageLoading,
  paginationLoading,
  showingData,
  searchedShowingData,
  getSystemSettings,
  normalizePkMobile,
  isValidPkMobile,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import ReactPaginate from "react-paginate";
import { Helmet } from "react-helmet";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from "react-icons/md";
import { FaUsers, FaSyncAlt, FaChartLine } from "react-icons/fa";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "./customers_segments.css";

//importing context consumer here
import { UserContext } from "../../../../contexts/User";
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import CustomerOrderList from "./CustomerOrderList";
import { useGeneralHooks } from "../../../../hooks/generalHooks";
import { useDebounce } from "../../../../hooks/useDebounceCustomer";

const Customers = () => {
  //getting context values here
  const {
    //common
    loading,
    setLoading,
    generalSettings,
  } = useContext(SettingsContext);

  const {
    authUserInfo,

    //customer
    customerList,
    setCustomerList,
    setPaginatedCustomer,
    customerForSearch,
    setCustomerForSearch,

    //pagination
    dataPaginating,
    setDataPaginating,
  } = useContext(UserContext);

  const {
    //branch
    branchForSearch,
  } = useContext(RestaurantContext);

  const { t } = useTranslation();

  // States hook here
  //new customer
  let [newCustomer, setNewCustomer] = useState({
    name: "",
    email: "",
    blacklist: 0,
    phn_no: "",
    address: "",
    branch: null,
    selectedBranch: null,
    edit: false,
    editSlug: null,
    uploading: false,
  });
  const [cusotmerOrder, setCustomerOrder] = useState({
    name: "",
    orders: [],
    modal: false,
  });

  //search result
  const [searchedCustomer, setSearchedCustomer] = useState({
    list: null,
    searched: false,
  });
  const [isDownloadReady, setIsDownloadReady] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 500);
  const [showFilters, setShowFilters] = useState(false);
  const [checkPass, setCheckPass] = useState("");
  const [metrics, setMetrics] = useState(null);
  const passModal = useRef("");
  const componentRef = useRef();
  const isFirstMount = useRef(true);
  const { csvPassword } = useGeneralHooks();

  const updateCustomerData = (data) => {
    if (!data) return;
    const paginator =
      data[0] && (data[0].current_page !== undefined || Array.isArray(data[0].data))
        ? data[0]
        : data.current_page !== undefined || Array.isArray(data.data)
          ? data
          : data[0];

    if (paginator) {
      setCustomerList(paginator);
    }
    const metricsData =
      data[2] || (!Array.isArray(data[1]) ? data[1] : data.metrics);
    if (metricsData) {
      setMetrics(metricsData);
    }
    if (Array.isArray(data[1])) {
      setCustomerForSearch(data[1]);
    } else if (paginator && Array.isArray(paginator.data)) {
      setCustomerForSearch(paginator.data);
    }
  };

  const fetchCustomers = (type = null, page = 1, search = undefined) => {
    setDataPaginating(true);
    let url = `${BASE_URL}/settings/get-customer-list?page=${page}&per_page=100`;

    const currentType =
      type !== null && type !== undefined ? type : selectedSegment;
    if (currentType && currentType !== "all") {
      url += `&type=${currentType}`;
    }

    const searchParam = search !== undefined ? search : debouncedSearch;
    if (searchParam && searchParam.trim().length > 0) {
      url += `&search=${encodeURIComponent(searchParam.trim())}`;
    }

    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setDataPaginating(false);
        if (res.data) {
          updateCustomerData(res.data);
        }
      })
      .catch((error) => {
        setDataPaginating(false);
      });
  };

  //useEffect == componentDidMount and debounced search
  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      fetchCustomers(null, 1, "");
      return;
    }
    fetchCustomers(selectedSegment, 1, debouncedSearch);
  }, [debouncedSearch]);

  //set name, phn no hook
  const handleSetNewCustomer = (e) => {
    const { name, value } = e.target;
    const nextValue = name === "phn_no" ? normalizePkMobile(value) : value;
    setNewCustomer({ ...newCustomer, [name]: nextValue });
  };

  //set branch hook
  const handleSetBranch = (branch) => {
    setNewCustomer({ ...newCustomer, branch });
  };

  //Save New customer
  const handleSaveNewCustomer = (e) => {
    e.preventDefault();
    let checkBranch = false;
    if (
      (authUserInfo.details !== null &&
        authUserInfo.details.user_type !== "staff" &&
        authUserInfo.details.user_type !== "manager") ||
      authUserInfo.details.user_type !== "waiter"
    ) {
      checkBranch = true;
    }
    if (checkBranch) {
      if (
        newCustomer.branch !== null &&
        newCustomer.phn_no &&
        newCustomer.name
      ) {
        if (!isValidPkMobile(newCustomer.phn_no)) {
          // toast.error(`${_t(t("Please enter valid phone no (03XXXXXXXXX)"))}`, {
          //   position: "bottom-center",
          //   autoClose: 10000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   className: "text-center toast-notification",
          // });
          return false;
        }
        setNewCustomer({
          ...newCustomer,
          uploading: true,
        });
        const customerUrl = BASE_URL + `/settings/new-customer`;
        let formData = new FormData();
        formData.append("name", newCustomer.name);
        formData.append("phn_no", newCustomer.phn_no);
        formData.append("email", newCustomer.email);
        formData.append("address", newCustomer.address);
        formData.append("branch_id", newCustomer.branch.id);
        formData.append("blacklist", newCustomer.blacklist);
        return axios
          .post(customerUrl, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setNewCustomer({
              name: "",
              email: "",
              blacklist: 0,
              phn_no: "",
              address: "",
              branch: null,
              selectedBranch: null,
              edit: false,
              editSlug: null,
              uploading: false,
            });
            updateCustomerData(res.data);
            setLoading(false);
            toast.success(`${_t(t("Customer has been added"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
            document.getElementById("close-btn").click();
          })
          .catch((error) => {
            setLoading(false);
            setNewCustomer({
              ...newCustomer,
              uploading: false,
            });
            if (error && error.response.data.errors) {
              if (error.response.data.errors.phn_no) {
                error.response.data.errors.phn_no.forEach((item) => {
                  if (item === "A customer exists with this phone number") {
                    toast.error(
                      `${_t(t("A customer exists with this phone number"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      },
                    );
                  }
                });
              }
            }
          });
      } else {
        toast.error(
          `${_t(t("Please select a branch, fill name and phone no"))}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          },
        );
      }
    } else {
      if (!isValidPkMobile(newCustomer.phn_no)) {
        // toast.error(`${_t(t("Please enter valid phone no (03XXXXXXXXX)"))}`, {
        //   position: "bottom-center",
        //   autoClose: 10000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   className: "text-center toast-notification",
        // });
        return false;
      }
      setNewCustomer({
        ...newCustomer,
        uploading: true,
      });
      const customerUrl = BASE_URL + `/settings/new-customer`;
      let formData = new FormData();
      formData.append("name", newCustomer.name);
      formData.append("phn_no", newCustomer.phn_no);
      formData.append("email", newCustomer.email);
      formData.append("address", newCustomer.address);
      formData.append("blacklist", newCustomer.blacklist);
      if (authUserInfo.details !== null) {
        formData.append("branch_id", authUserInfo.details.branch_id);
      }
      return axios
        .post(customerUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setNewCustomer({
            name: "",
            blacklist: 0,
            email: "",
            phn_no: "",
            address: "",
            branch: null,
            selectedBranch: null,
            edit: false,
            editSlug: null,
            uploading: false,
          });
          updateCustomerData(res.data);
          setLoading(false);
          toast.success(`${_t(t("Customer has been added"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          document.getElementById("close-btn").click();
        })
        .catch((error) => {
          setLoading(false);
          setNewCustomer({
            ...newCustomer,
            uploading: false,
          });
          if (error && error.response.data.errors) {
            if (error.response.data.errors.phn_no) {
              error.response.data.errors.phn_no.forEach((item) => {
                if (item === "A customer exists with this phone number") {
                  toast.error(
                    `${_t(t("A customer exists with this phone number"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    },
                  );
                }
              });
            }
          }
        });
    }
  };

  //set edit true & values
  const handleSetEdit = (slug) => {
    let customer = customerForSearch.find((item) => {
      return item.slug === slug;
    });

    let selectedOptionForBranch = null;
    if (
      authUserInfo.details !== null &&
      authUserInfo.details.user_type !== "staff" &&
      authUserInfo.details.user_type !== "manager" &&
      authUserInfo.details.user_type !== "waiter"
    ) {
      if (customer.branch_id) {
        selectedOptionForBranch = branchForSearch.filter((branchItem) => {
          return branchItem.id === parseInt(customer.branch_id);
        });
      }
    }
    setNewCustomer({
      ...newCustomer,
      name: customer.name,
      email: customer.email,
      phn_no: normalizePkMobile(customer.phn_no),
      blacklist: customer.blacklist,
      address: customer.address,
      selectedBranch: selectedOptionForBranch
        ? selectedOptionForBranch[0]
        : null,
      editSlug: customer.slug,
      edit: true,
    });
  };

  //update customer
  const handleUpdateCustomer = (e) => {
    e.preventDefault();
    if (!isValidPkMobile(newCustomer.phn_no)) {
      // toast.error(`${_t(t("Please enter valid phone no (03XXXXXXXXX)"))}`, {
      //   position: "bottom-center",
      //   autoClose: 10000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   className: "text-center toast-notification",
      // });
      return false;
    }
    setNewCustomer({
      ...newCustomer,
      uploading: true,
    });
    const customerUrl = BASE_URL + `/settings/update-customer`;
    let formData = new FormData();
    formData.append("name", newCustomer.name);
    formData.append("phn_no", newCustomer.phn_no);
    formData.append("email", newCustomer.email);
    formData.append("address", newCustomer.address);
    formData.append("blacklist", newCustomer.blacklist);
    if (newCustomer.branch !== null) {
      formData.append("branch_id", newCustomer.branch.id);
    }
    formData.append("editSlug", newCustomer.editSlug);
    return axios
      .post(customerUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewCustomer({
          name: "",
          email: "",
          blacklist: 0,
          phn_no: "",
          address: "",
          branch: null,
          selectedBranch: null,
          edit: false,
          editSlug: null,
          uploading: false,
        });
        updateCustomerData(res.data);
        if (Array.isArray(res.data[1])) {
          setSearchedCustomer({
            ...searchedCustomer,
            list: res.data[1],
          });
        }
        setLoading(false);
        toast.success(`${_t(t("Customer has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById("close-btn").click();
      })
      .catch((error) => {
        setLoading(false);
        setNewCustomer({
          ...newCustomer,
          uploading: false,
        });
        if (error && error.response.data.errors) {
          if (error.response.data.errors.phn_no) {
            error.response.data.errors.phn_no.forEach((item) => {
              if (item === "A customer exists with this phone number") {
                toast.error(
                  `${_t(t("A customer exists with this phone number"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  },
                );
              }
            });
          }
        }
      });
  };

  const handleSegmentClick = (segmentKey) => {
    const nextSegment = selectedSegment === segmentKey ? null : segmentKey;
    setSelectedSegment(nextSegment);
    fetchCustomers(nextSegment, 1, debouncedSearch);
  };

  const handleClearAllFilters = () => {
    setSelectedSegment(null);
    setSearchQuery("");
    fetchCustomers(null, 1, "");
  };

  const handlePagination = (pageNo) => {
    fetchCustomers(selectedSegment, pageNo, debouncedSearch);
  };

  //search customers here via debounced search query
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  //delete confirmation modal of waiter
  const handleDeleteConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  handleDeleteCustomer(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button
                className="btn btn-success ml-2 px-3 rounded"
                onClick={onClose}
              >
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleCustomerSubmit = (e) => {
    if (csvPassword && checkPass !== csvPassword) {
      passModal.current.classList += " showing";
      return false;
    } else {
      handleCustomerDownload(e);
    }
  };

  const handleCustomerDownload = (e) => {
    e.preventDefault();
    if (csvPassword && checkPass !== csvPassword) {
      toast.error(`${_t(t("Incorrect Password"))}`);
      return false;
    } else {
      passModal.current.classList.remove("showing");
      setIsDownloadReady(true);
      setTimeout(() => {
        componentRef.current.handleDownload();
      }, 1000);

      setTimeout(() => {
        setIsDownloadReady(false);
      }, 5000);
    }
  };

  //delete customer here
  const handleDeleteCustomer = (slug) => {
    setLoading(true);
    const customerUrl = BASE_URL + `/settings/delete-customer/${slug}`;
    return axios
      .get(customerUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        updateCustomerData(res.data);
        if (Array.isArray(res.data[1])) {
          setSearchedCustomer({
            ...searchedCustomer,
            list: res.data[1],
          });
        }
        setLoading(false);
        toast.success(`${_t(t("Customer has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const handleGetCustomerOrder = (id, branch_id, name) => {
    let url = BASE_URL + "/settings/get-customer-orders/" + id;
    if (branch_id) {
      url += `/${branch_id}`;
    }
    setDataPaginating(true);
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setDataPaginating(false);
        if (res.data) {
          if (res.data.length === 0) {
            toast.error(`${_t(t("No orders found"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
            return false;
          }
          setCustomerOrder((curr) => ({
            ...curr,
            orders: res.data,
            name: name,
            modal: true,
          }));
          setLoading(false);
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const segmentTitles = {
    all: _t(t("Total Customers")),
    NC: _t(t("New Customers")),
    vip: _t(t("VIP Customers")),
    rep: _t(t("Repeat Buyers")),
    zero: _t(t("Zero Orders")),
    dormant: _t(t("Dormant Customers")),
    frequent: _t(t("Frequent Buyers")),
    onetime: _t(t("One-time Buyers")),
    MVC: _t(t("Most Valuable Customers")),
    mvc: _t(t("Most Valuable Customers")),
  };

  const segmentsList = [
    {
      key: "NC",
      title: _t(t("New Customers")),
      desc: _t(t("Joined in last 30 days")),
      borderClass: "border-new",
      badgeClass: "bg-new",
      count: metrics && metrics.NC !== undefined ? metrics.NC : "-",
    },
    {
      key: "vip",
      title: _t(t("VIP Customers")),
      desc: _t(t("More than 20 orders")),
      borderClass: "border-vip",
      badgeClass: "bg-vip",
      count: metrics && metrics.vip !== undefined ? metrics.vip : "-",
    },
    {
      key: "rep",
      title: _t(t("Repeat Buyers")),
      desc: _t(t("More than 1 order")),
      borderClass: "border-repeat",
      badgeClass: "bg-repeat",
      count: metrics && metrics.rep !== undefined ? metrics.rep : "-",
    },
    {
      key: "zero",
      title: _t(t("Zero Orders")),
      desc: _t(t("Having 0 orders")),
      borderClass: "border-zero",
      badgeClass: "bg-zero",
      count: metrics && metrics.zero !== undefined ? metrics.zero : "-",
    },
    {
      key: "dormant",
      title: _t(t("Dormant Customers")),
      desc: _t(t("No orders in last 60 days")),
      borderClass: "border-dormant",
      badgeClass: "bg-dormant",
      count: metrics && metrics.dormant !== undefined ? metrics.dormant : "-",
    },
    {
      key: "frequent",
      title: _t(t("Frequent Buyers")),
      desc: _t(t("More than 5 orders")),
      borderClass: "border-frequent",
      badgeClass: "bg-frequent",
      count: metrics && metrics.frequent !== undefined ? metrics.frequent : "-",
    },
    {
      key: "onetime",
      title: _t(t("One-time Buyers")),
      desc: _t(t("Only one order placed")),
      borderClass: "border-onetime",
      badgeClass: "bg-onetime",
      count: metrics && metrics.onetime !== undefined ? metrics.onetime : "-",
    },
    {
      key: "mvc",
      title: _t(t("Most Valuable Customers")),
      desc: _t(t("Spending more than 10,000")),
      borderClass: "border-mvc",
      badgeClass: "bg-mvc",
      count: metrics && metrics.mvc !== undefined ? metrics.mvc : "-",
    },
  ];

  const customerListData =
    customerList && Array.isArray(customerList.data)
      ? customerList.data
      : Array.isArray(customerList)
        ? customerList
        : [];
  const currentPage =
    customerList && customerList.current_page ? customerList.current_page : 1;
  const perPage =
    customerList && customerList.per_page ? customerList.per_page : 100;

  return (
    <>
      <Helmet>
        <title>{_t(t("Customers"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="customer report"
        sheet="sheet 1"
        buttonText="customer details"
        ref={componentRef}
      />

      {/* Add modal */}
      <div className="modal fade" id="addCustomer" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newCustomer.edit
                    ? _t(t("Add new customer"))
                    : _t(t("Update customer"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newCustomer.uploading === false ? (
                <div key="fragment-customer-1">
                  <form
                    onSubmit={
                      !newCustomer.edit
                        ? handleSaveNewCustomer
                        : handleUpdateCustomer
                    }
                  >
                    <div>
                      <label htmlFor="name" className="form-label">
                        {_t(t("Name"))} <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="e.g. Mr. John"
                        value={newCustomer.name || ""}
                        required
                        onChange={handleSetNewCustomer}
                      />
                    </div>

                    <div className="row">
                      {authUserInfo.details !== null &&
                        authUserInfo.details.user_type !== "staff" &&
                        authUserInfo.details.user_type !== "manager" &&
                        authUserInfo.details.user_type !== "waiter" && (
                          <div className="col-9 mt-3">
                            <label className="form-label mb-0">
                              {_t(t("Select a branch"))}{" "}
                              {newCustomer.edit ? (
                                <small className="text-primary">
                                  {"( "}
                                  {_t(
                                    t(
                                      "Leave empty if you do not want to change branch",
                                    ),
                                  )}
                                  {" )"}
                                </small>
                              ) : (
                                <small className="text-danger">*</small>
                              )}
                            </label>
                            {newCustomer.edit &&
                              newCustomer.selectedBranch !== null && (
                                <ul className="list-group list-group-horizontal-sm row col-12 mb-2 ml-md-1">
                                  <li className="list-group-item col-12 col-md-3 bg-success rounded-sm py-1 px-2 my-1 text-center">
                                    {newCustomer.selectedBranch.name}
                                  </li>
                                </ul>
                              )}
                            <Select
                              options={branchForSearch}
                              components={makeAnimated()}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              className="basic-multi-select mt-2"
                              classNamePrefix="select"
                              onChange={handleSetBranch}
                              placeholder={_t(t("Please select a branch"))}
                            />
                          </div>
                        )}
                      <div className="col-3 mt-3">
                        <label
                          forHtml="blacklist"
                          className="d-block form-label"
                        >
                          {_t(t("Blacklist Customer"))}
                        </label>
                        <input
                          type="checkbox"
                          className="ml-2 mt-2 form-check-input"
                          id="blacklist"
                          name="blacklist"
                          onChange={(e) => {
                            setNewCustomer((curr) => ({
                              ...curr,
                              blacklist: curr.blacklist ? 0 : 1,
                            }));
                          }}
                          checked={parseInt(newCustomer.blacklist) === 1}
                        />
                      </div>
                    </div>

                    <div className="mt-3">
                      <label htmlFor="email" className="form-label">
                        {_t(t("Email"))}
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="e.g. customer@example.com"
                        value={newCustomer.email || ""}
                        onChange={handleSetNewCustomer}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="phn_no" className="form-label">
                        {_t(t("Phone number"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phn_no"
                        name="phn_no"
                        placeholder="03XXXXXXXXX"
                        maxLength={11}
                        value={newCustomer.phn_no || ""}
                        onChange={handleSetNewCustomer}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="address" className="form-label">
                        {_t(t("Address"))}
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="address"
                        name="address"
                        placeholder="Type customer address"
                        value={newCustomer.address || ""}
                        onChange={handleSetNewCustomer}
                      />
                    </div>

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newCustomer.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newCustomer.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            <div className="col-12 mb-0 cust-main-column">
              {newCustomer.uploading === true || loading === true ? (
                pageLoading()
              ) : (
                <div className="t-bg-white ">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={loading || dataPaginating} />
                  {/* spin loading ends */}
                  {/* Top Row: ONLY Header (Customers + Search + Buttons) -> FIXED AT TOP */}
                  <div className="row gx-2 align-items-center t-pl-15 t-pr-15 t-shadow cust-header-bar">
                    <div className="col-12 cust-header-section">
                      <div className="cust-header-inner">
                        <div className="cust-header-left">
                          <h4 className="cust-main-heading mb-0 text-capitalize">
                            Customers
                          </h4>
                        </div>

                        <div className="cust-header-right">
                          {/* Search Bar */}
                          <div className="cust-search-wrapper">
                            <i
                              className="fa fa-search cust-search-icon"
                              aria-hidden="true"
                            ></i>
                            <input
                              type="text"
                              className="cust-search-input"
                              placeholder={_t(t("Search customers..."))}
                              onChange={handleSearch}
                              value={searchQuery}
                            />
                            {searchQuery && (
                              <button
                                type="button"
                                className="cust-search-clear"
                                onClick={() => {
                                  setSearchQuery("");
                                  fetchCustomers(selectedSegment, 1, "");
                                }}
                                title="Clear"
                              >
                                &times;
                              </button>
                            )}
                          </div>

                          {/* Filters Button */}
                          <button
                            type="button"
                            className={`cust-filter-btn ${showFilters || selectedSegment ? "active" : ""}`}
                            onClick={() => setShowFilters(!showFilters)}
                            title={
                              showFilters
                                ? _t(t("Hide Filters"))
                                : _t(t("Show Filters"))
                            }
                          >
                            <i
                              className="fa fa-filter cust-btn-icon"
                              aria-hidden="true"
                            ></i>
                            <span>{_t(t("FILTERS"))}</span>
                            {selectedSegment && (
                              <span className="cust-filter-badge">1</span>
                            )}
                          </button>

                          {/* Add New Button */}
                          <button
                            type="button"
                            className="cust-action-btn cust-btn-add text-uppercase"
                            data-toggle="modal"
                            data-target="#addCustomer"
                            onClick={() => {
                              setNewCustomer({
                                ...newCustomer,
                                branch: null,
                                edit: false,
                                uploading: false,
                              });
                            }}
                          >
                            <i
                              className="fa fa-plus cust-btn-icon"
                              aria-hidden="true"
                            ></i>
                            <span>{_t(t("ADD NEW"))}</span>
                          </button>

                          {/* Download Button */}
                          <button
                            type="button"
                            className="cust-action-btn cust-btn-download text-uppercase"
                            onClick={handleCustomerSubmit}
                          >
                            <i
                              className="fa fa-table cust-btn-icon"
                              aria-hidden="true"
                            ></i>
                            <span>{_t(t("DOWNLOAD"))}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Main Body: Fixed Above pagination Layout */}
                  <div className="fk-scroll--order-history cust-body-scroll">
                    <div className="t-pl-15 t-pr-15 cust-main-layout">
                      <div className="cust-top-section">
                        {/* Compact Top 4 KPI Metrics Cards with Equal Heights */}
                        <div className="cust-kpi-wrapper">
                          <div className="row gx-2 gy-1">
                            <div className="col-12 col-sm-6 col-lg-3 d-flex">
                              <div className="cust-kpi-card">
                                <div>
                                  <div className="cust-kpi-title">
                                    {_t(t("Total Customers"))}
                                  </div>
                                  <div className="cust-kpi-value">
                                    {metrics && metrics.all !== undefined
                                      ? Number(metrics.all).toLocaleString()
                                      : customerList &&
                                          customerList.total !== undefined
                                        ? Number(
                                            customerList.total,
                                          ).toLocaleString()
                                        : "-"}
                                  </div>
                                </div>
                                <div className="cust-kpi-icon purple">
                                  <FaUsers />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3 d-flex">
                              <div className="cust-kpi-card">
                                <div>
                                  <div className="cust-kpi-title">
                                    {_t(t("Repeat Rate"))}
                                  </div>
                                  <div className="cust-kpi-value">
                                    {metrics &&
                                    metrics.repeat_rate !== undefined
                                      ? `${metrics.repeat_rate}%`
                                      : "-"}
                                  </div>
                                </div>
                                <div className="cust-kpi-icon green">
                                  <FaSyncAlt />
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3 d-flex">
                              <div className="cust-kpi-card">
                                <div>
                                  <div className="cust-kpi-title">
                                    {_t(t("Average Order Value"))}
                                  </div>
                                  <div className="cust-kpi-value">
                                    {metrics &&
                                    metrics.average_orders !== undefined
                                      ? Math.round(
                                          Number(metrics.average_orders),
                                        ).toLocaleString()
                                      : "-"}
                                  </div>
                                </div>
                                <div className="cust-kpi-icon orange">PKR</div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-3 d-flex">
                              <div className="cust-kpi-card">
                                <div>
                                  <div className="cust-kpi-title">
                                    {_t(t("Retention Rate"))}
                                  </div>
                                  <div className="cust-kpi-value">
                                    {metrics &&
                                    metrics.retention_rate !== undefined
                                      ? `${metrics.retention_rate}%`
                                      : "-"}
                                  </div>
                                </div>
                                <div className="cust-kpi-icon blue">
                                  <FaChartLine />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Smart Segments Section (Shown when showFilters === true, Scrolls UP!) */}
                        {showFilters && (
                          <div className="cust-segments-section">
                            <div className="cust-segments-header">
                              <div className="d-flex align-items-center">
                                <h5 className="cust-segments-title mb-0 mr-2">
                                  {_t(t("Smart Segments"))}
                                </h5>
                                <span
                                  className="text-muted"
                                  style={{ fontSize: "11px" }}
                                >
                                  ({_t(t("Click any card to filter"))})
                                </span>
                              </div>
                              {selectedSegment && (
                                <div className="d-flex align-items-center">
                                  <span className="cust-active-filter-text mr-2">
                                    {_t(t("Filtered by:"))}{" "}
                                    <strong>
                                      {segmentTitles[selectedSegment]}
                                    </strong>
                                  </span>
                                  <button
                                    type="button"
                                    className="cust-clear-filter-btn"
                                    onClick={handleClearAllFilters}
                                  >
                                    {_t(t("Clear Filter"))}
                                  </button>
                                </div>
                              )}
                            </div>

                            <div className="cust-segments-grid">
                              {segmentsList.map((segment) => {
                                const isActive =
                                  selectedSegment === segment.key;
                                return (
                                  <div
                                    key={segment.key}
                                    className="cust-segment-card-wrapper"
                                  >
                                    <div
                                      className={`cust-segment-card ${segment.borderClass} ${isActive ? "active" : ""}`}
                                      onClick={() =>
                                        handleSegmentClick(segment.key)
                                      }
                                      title={
                                        isActive
                                          ? _t(t("Click to clear filter"))
                                          : _t(t("Click to filter customers"))
                                      }
                                    >
                                      <div className="cust-segment-top">
                                        <div className="cust-segment-name">
                                          {segment.title}
                                          {isActive && (
                                            <span className="cust-segment-active-tag">
                                              {_t(t("Active"))}
                                            </span>
                                          )}
                                        </div>
                                        <span
                                          className={`cust-segment-badge ${segment.badgeClass}`}
                                        >
                                          {segment.count}
                                        </span>
                                      </div>
                                      <div className="cust-segment-bottom">
                                        <div className="cust-segment-desc">
                                          {segment.desc}
                                        </div>
                                        <span
                                          className="cust-segment-action"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleSegmentClick(segment.key);
                                          }}
                                        >
                                          {_t(t("View Customers"))}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        {/* Active Filter banner when showFilters is closed (Scrolls UP!) */}
                        {!showFilters && selectedSegment && (
                          <div className="col-12 cust-active-filter-wrapper">
                            <div className="cust-active-filter-banner">
                              <span className="cust-active-filter-text">
                                <i className="fa fa-filter mr-1 text-primary"></i>
                                {_t(t("Active Filter:"))}{" "}
                                <strong>
                                  {segmentTitles[selectedSegment]}
                                </strong>
                              </span>
                              <div>
                                <button
                                  type="button"
                                  className="cust-clear-filter-btn mr-2"
                                  onClick={() => setShowFilters(true)}
                                  style={{ background: "#e2e8f0" }}
                                >
                                  {_t(t("Show Filters"))}
                                </button>
                                <button
                                  type="button"
                                  className="cust-clear-filter-btn"
                                  onClick={handleClearAllFilters}
                                >
                                  {_t(t("Clear Filter"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="cust-table-responsive">
                        <table className="table table-bordered table-hover min-table-height cust-table">
                          <thead className="align-middle cust-thead-sticky">
                            <tr>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Name"))}
                              </th>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("email"))}
                              </th>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Phn no"))}
                              </th>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Address"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Branch"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("First Order"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Last Order"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Total Order"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Total Spending"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Action"))}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                            {!searchedCustomer.searched
                              ? [
                                  customerList && [
                                    customerListData.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="11"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      customerListData.map((item, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >
                                            <th
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {index +
                                                1 +
                                                (currentPage - 1) * perPage}
                                            </th>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              <span
                                                className="cursor-pointer text-primary text-decoration-underline"
                                                onClick={() =>
                                                  handleGetCustomerOrder(
                                                    item.id,
                                                    item.branch_id,
                                                    item.name,
                                                  )
                                                }
                                              >
                                                {item.name}
                                              </span>
                                            </td>

                                            <td className="xsm-text align-middle text-center">
                                              {item.email || "-"}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.phn_no ? (
                                                <a
                                                  href={`tel:${item.phn_no}`}
                                                  rel="noopener noreferrer"
                                                >
                                                  {item.phn_no}
                                                </a>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {item.address || "-"}
                                            </td>

                                            <td className="xsm-text align-middle text-center">
                                              {item.branch_name || "-"}
                                            </td>
                                            <td className="xsm-text align-middle text-center">
                                              {item.first_order_date &&
                                              item.first_order_date !== "-" ? (
                                                <Moment format="DD-MM-YYYY hh:mm A">
                                                  {item.first_order_date}
                                                </Moment>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td className="xsm-text align-middle text-center">
                                              {item.last_order_date &&
                                              item.last_order_date !== "-" ? (
                                                <Moment format="DD-MM-YYYY hh:mm A">
                                                  {item.last_order_date}
                                                </Moment>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td className="xsm-text align-middle text-center">
                                              {item.total_orders || "-"}
                                            </td>
                                            <td className="xsm-text align-middle text-center">
                                              {item.total_payable || "-"}
                                            </td>

                                            <td className="xsm-text text-capitalize align-middle text-center">
                                              {/* <div className="dropdown">
                                                <button
                                                  className="btn t-bg-clear t-text-dark--light-40"
                                                  type="button"
                                                  data-toggle="dropdown"
                                                >
                                                  <i className="fa fa-ellipsis-h"></i>
                                                </button>
                                                <div className="dropdown-menu">
                                                  <button
                                                    className="dropdown-item sm-text text-capitalize"
                                                    onClick={() => {
                                                      setNewCustomer({
                                                        ...newCustomer,
                                                        branch: null,
                                                      });
                                                      handleSetEdit(item.slug);
                                                    }}
                                                    data-toggle="modal"
                                                    data-target="#addCustomer"
                                                  >
                                                    <span className="t-mr-8">
                                                      <i className="fa fa-pencil"></i>
                                                    </span>
                                                    {_t(t("Edit"))}
                                                  </button>

                                                  <button
                                                    className="dropdown-item sm-text text-capitalize"
                                                    onClick={() => {
                                                      handleDeleteConfirmation(
                                                        item.slug
                                                      );
                                                    }}
                                                  >
                                                    <span className="t-mr-8">
                                                      <i className="fa fa-trash"></i>
                                                    </span>
                                                    {_t(t("Delete"))}
                                                  </button>
                                                </div>
                                              </div> */}
                                              <button
                                                title="Edit"
                                                className="btn btn-primary ml-2 rounded-sm del-btn"
                                                onClick={() => {
                                                  setNewCustomer({
                                                    ...newCustomer,
                                                    branch: null,
                                                  });
                                                  handleSetEdit(item.slug);
                                                }}
                                                data-toggle="modal"
                                                data-target="#addCustomer"
                                              >
                                                <i
                                                  className="fa fa-pencil edit-icon"
                                                  aria-hidden="true"
                                                ></i>
                                              </button>
                                              <button
                                                title="Delete"
                                                className="btn btn-danger ml-2 rounded-sm del-btn"
                                                onClick={() =>
                                                  handleDeleteConfirmation(
                                                    item.slug,
                                                  )
                                                }
                                              >
                                                <MdDelete className="del-icon" />
                                              </button>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ),
                                  ],
                                ]
                              : [
                                  /* searched data, logic === haveData*/
                                  searchedCustomer && [
                                    searchedCustomer.list.length === 0 ? (
                                      <tr className="align-middle">
                                        <td
                                          scope="row"
                                          colSpan="11"
                                          className="xsm-text align-middle text-center"
                                        >
                                          {_t(t("No data available"))}
                                        </td>
                                      </tr>
                                    ) : (
                                      searchedCustomer.list.map(
                                        (item, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {index +
                                                  1 +
                                                  (customerList.current_page -
                                                    1) *
                                                    customerList.per_page}
                                              </th>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                <span
                                                  className="cursor-pointer text-primary text-decoration-underline"
                                                  onClick={() =>
                                                    handleGetCustomerOrder(
                                                      item.id,
                                                      item.branch_id,
                                                      item.name,
                                                    )
                                                  }
                                                >
                                                  {item.name}
                                                </span>
                                              </td>

                                              <td className="xsm-text align-middle text-center">
                                                {item.email || "-"}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.phn_no ? (
                                                  <a
                                                    href={`tel:${item.phn_no}`}
                                                    rel="noopener noreferrer"
                                                  >
                                                    {item.phn_no}
                                                  </a>
                                                ) : (
                                                  "-"
                                                )}
                                              </td>
                                              <td className="xsm-text align-middle text-center">
                                                {item.address || "-"}
                                              </td>

                                              <td className="xsm-text align-middle text-center">
                                                {item.branch_name || "-"}
                                              </td>
                                              <td className="xsm-text align-middle text-center">
                                                {item.first_order_date &&
                                                item.first_order_date !==
                                                  "-" ? (
                                                  <Moment format="DD-MM-YYYY hh:mm A">
                                                    {item.first_order_date}
                                                  </Moment>
                                                ) : (
                                                  "-"
                                                )}
                                              </td>
                                              <td className="xsm-text align-middle text-center">
                                                {item.last_order_date &&
                                                item.last_order_date !== "-" ? (
                                                  <Moment format="DD-MM-YYYY hh:mm A">
                                                    {item.last_order_date}
                                                  </Moment>
                                                ) : (
                                                  "-"
                                                )}
                                              </td>
                                              <td className="xsm-text align-middle text-center">
                                                {item.total_orders || "-"}
                                              </td>
                                              <td className="xsm-text align-middle text-center">
                                                {item.total_payable || "-"}
                                              </td>

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                <button
                                                  title="Edit"
                                                  className="btn btn-primary ml-2 rounded-sm del-btn"
                                                  onClick={() => {
                                                    setNewCustomer({
                                                      ...newCustomer,
                                                      branch: null,
                                                    });
                                                    handleSetEdit(item.slug);
                                                  }}
                                                  data-toggle="modal"
                                                  data-target="#addCustomer"
                                                >
                                                  <i
                                                    className="fa fa-pencil edit-icon"
                                                    aria-hidden="true"
                                                  ></i>
                                                </button>
                                                <button
                                                  title="Delete"
                                                  className="btn btn-danger ml-2 rounded-sm del-btn"
                                                  onClick={() =>
                                                    handleDeleteConfirmation(
                                                      item.slug,
                                                    )
                                                  }
                                                >
                                                  <MdDelete className="del-icon" />
                                                </button>
                                              </td>
                                            </tr>
                                          );
                                        },
                                      )
                                    ),
                                  ],
                                ]}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* pagination loading effect */}
              {newCustomer.uploading === true || loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedCustomer.searched ? (
                      <div key="fragment4" className="cust-pagination-fixed">
                        <div className="t-bg-white t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {customerList && customerList.last_page ? (
                                <ReactPaginate
                                  pageCount={Number(customerList.last_page || 1)}
                                  forcePage={Math.max(
                                    0,
                                    Math.min(
                                      Number(customerList.last_page || 1) - 1,
                                      Number(customerList.current_page || 1) - 1
                                    )
                                  )}
                                  disableInitialCallback={true}
                                  marginPagesDisplayed={5}
                                  pageRangeDisplayed={2}
                                  onPageChange={(page) => {
                                    handlePagination(page.selected + 1);
                                  }}
                                  breakLabel={". . ."}
                                  breakClassName={"px-2"}
                                  containerClassName={"t-list d-flex"}
                                  pageClassName={"t-list__item mr-0"}
                                  previousLabel={
                                    <i className="las la-angle-double-left"></i>
                                  }
                                  nextLabel={
                                    <i className="las la-angle-double-right"></i>
                                  }
                                  pageLinkClassName={
                                    "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
                                  }
                                  previousClassName={
                                    "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
                                  }
                                  nextClassName={
                                    "t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
                                  }
                                  activeClassName={"pagination-active"}
                                  activeLinkClassName={"text-white"}
                                />
                              ) : null}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {customerList &&
                                    customerList.total !== undefined
                                      ? showingData(customerList)
                                      : `Showing ${customerListData.length} of ${customerListData.length}`}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div
                        key="fragment-searched"
                        className="cust-pagination-fixed"
                      >
                        <div className="t-bg-white t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              <ul className="t-list d-flex">
                                <li className="t-list__item no-pagination-style">
                                  <button
                                    className="btn btn-primary btn-sm rounded"
                                    onClick={handleClearAllFilters}
                                  >
                                    {_t(t("Clear Search"))}
                                  </button>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {searchedShowingData(
                                      searchedCustomer,
                                      customerForSearch,
                                    )}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
          </div>
        </div>
        <CustomerOrderList
          show={cusotmerOrder.modal}
          name={cusotmerOrder.name}
          cusotmerOrder={cusotmerOrder.orders}
          onHide={() => setCustomerOrder((curr) => ({ ...curr, modal: false }))}
        />
      </main>
      <div className="d-none">
        <table className="table table-bordered" id="table-to-xls">
          <thead className="align-middle">
            <tr style={{ border: "0px" }}>
              <th colspan="10" style={{ border: "0px" }}>
                <div className="row">
                  <div className="col-12">
                    <h3 className="text-center">
                      {getSystemSettings(generalSettings, "siteName")}
                    </h3>
                    <h3 className="text-center">Customers</h3>
                    <p className="text-center">
                      Date&nbsp;
                      <Moment format="LL">{new Date()}</Moment>
                    </p>
                  </div>
                </div>
              </th>
            </tr>
            <tr>
              <th scope="col">{_t(t("S/L"))}</th>

              <th scope="col">{_t(t("Name"))}</th>
              <th scope="col">{_t(t("Email"))}</th>
              <th scope="col">{_t(t("Phone No"))}</th>
              <th scope="col">{_t(t("Address"))}</th>

              <th scope="col">{_t(t("Branch"))}</th>

              <th scope="col">{_t(t("First Order"))}</th>

              <th scope="col">{_t(t("Last Order"))}</th>

              <th scope="col">{_t(t("Total Order"))}</th>

              <th scope="col">{_t(t("Total Spending"))}</th>
            </tr>
          </thead>
          <tbody className="align-middle">
            {isDownloadReady &&
              customerForSearch?.length &&
              customerForSearch.map((item, index) => {
                return (
                  <tr className="align-middle" key={index}>
                    <th scope="row">{index + 1}</th>

                    <td>{item.name}</td>

                    <td>{item.email || "-"}</td>

                    <td>{item.phn_no ? item.phn_no : "-"}</td>
                    <td>{item.address || "-"}</td>

                    <td>{item.branch_name || "-"}</td>

                    <td>
                      {item.first_order_date ? (
                        <Moment format="DD-MM-YYYY hh:mm A">
                          {item.first_order_date}
                        </Moment>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {item.last_order_date ? (
                        <Moment format="DD-MM-YYYY hh:mm A">
                          {item.last_order_date}
                        </Moment>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{item.total_orders || "-"}</td>
                    <td>{item.total_payable || "-"}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {/* password Modal */}
      <div
        className="modal fade"
        ref={passModal}
        id="passModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content" style={{ borderRadius: "1rem" }}>
            <div className="modal-body py-3">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form autoComplete="off" onSubmit={handleCustomerDownload}>
                  <div>
                    <div className="addons-list__item mt-1 mx-1 row">
                      <label
                        htmlFor="name"
                        className="form-label p-0 d-flex justify-content-between font-weight-md xslg-text mb-3"
                      >
                        <span className="mt-2">Enter Your Password</span>
                        <span
                          onClick={(e) => {
                            passModal.current.classList.remove("showing");
                          }}
                        >
                          <i className="fa fa-times-circle close-1 pointer-cursor"></i>
                        </span>
                      </label>

                      <input
                        type="password"
                        onKeyDown={(evt) =>
                          [
                            "e",
                            "E",
                            "+",
                            "-",
                            "ArrowUp",
                            "ArrowDown",
                            "ArrowLeft",
                            "ArrowRight",
                          ].includes(evt.key) && evt.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Enter Password"
                        autoComplete="off"
                        value={checkPass}
                        required
                        onChange={(e) => setCheckPass(e.target.value)}
                      />
                    </div>
                    <div className="mt-4">
                      <div className="row mt-1">
                        <div className="col-8"></div>
                        <div className="col-4">
                          <button
                            type="submit"
                            className="btn btn-success font-weight-bold sm-text text-uppercase t-width-max w-100"
                          >
                            {_t(t("Submit"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Customers;
